import React from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import Eyebrow from './Eyebrow';

interface LayoutProps {
  children: React.ReactNode;
}

/**
 * Three bands, each answering a different question:
 *   sidebar  — what the platform does (the daily work)
 *   eyebrow  — administering the platform, and your own account
 *   header   — where you are right now
 */
export default function Layout({ children }: LayoutProps) {
  return (
    // Der Grund der ganzen Anwendung. Vorher stand hier ein festes `#f8fafc`
    // als Inline-Stil — der schlägt jede Klasse und jede Variable, und genau
    // deshalb blieb in der dunklen Fassung eine weiße Fläche stehen.
    <div className="flex h-screen overflow-hidden bg-surface-sunk">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
        <Eyebrow />
        <Header />
        <main className="flex-1 overflow-y-auto p-6">{children}</main>
      </div>
    </div>
  );
}
